import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConfidentialityGuaranteed() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="confidentiality-guaranteed" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_60%)] opacity-20 pointer-events-none" />

      <div ref={ref} className={`container relative z-10 px-6 mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex justify-center mb-6">
          <ShieldCheck className="w-12 h-12 text-primary opacity-80" strokeWidth={1.5} />
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-foreground mb-8 tracking-tight leading-tight">
          Your privacy is our <span className="text-primary italic">highest mandate.</span>
        </h2>

        <p className="max-w-2xl mx-auto text-muted-foreground text-lg md:text-xl mb-12 font-sans leading-relaxed">
          We operate with a strict code of silence. Your identity, your concerns, and our findings remain sealed within a legal and ethical fortress.
        </p>

        <div className="relative inline-block group">
          {}
          <div className="absolute -inset-1 bg-primary/30 rounded-lg blur-md animate-pulse group-hover:bg-primary/50 transition-colors duration-500" />
          
          <Link to="/GetClarityPage">
            <Button size="lg" className="relative h-14 px-10 text-lg font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl transition-all duration-300 hover:scale-[1.02]">
              Schedule a Private Call
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}